import { Tooltip } from '@mui/material';
import ColoredLabel from '../../../components/ColoredLabel';

export const HJ_MIGRATION_COMPLETED = 'hj_migration_completed';
export const HJ_MIGRATION_OPTED_OUT = 'hj_migration_opted_out';
export const ONE_APP_TAG_DC = 'one_app_tag_dc';
export const IWA_HJ_MIG_DC_RESTRICTED_ACCESS =
  'iwa_hj_mig_dc_restricted_access';
export const HJ_MIGRATION_CSQ_TAG_ALREADY_LOADED =
  'hj_migration_csq_tag_already_loaded';

interface MigrationLabel {
  color: string;
  text: string;
  tooltip: string;
}

function getMigrationState(features: string[]): MigrationLabel | null {
  if (features.includes(HJ_MIGRATION_COMPLETED)) {
    return {
      color: 'var(--green)',
      text: 'Migrated to CS',
      tooltip: 'The paid HJ→CSQ migration is complete.',
    };
  }
  if (features.includes(HJ_MIGRATION_OPTED_OUT)) {
    return {
      color: 'var(--amber)',
      text: 'Opted out of CS migration',
      tooltip: 'The account declined the paid migration.',
    };
  }
  if (features.includes(ONE_APP_TAG_DC)) {
    return features.includes(IWA_HJ_MIG_DC_RESTRICTED_ACCESS)
      ? {
          color: 'var(--business)',
          text: 'HJ→CS dual collection',
          tooltip:
            'Collecting in both Hotjar and CSQ. Access is restricted during this period.',
        }
      : {
          color: 'var(--red)',
          text: 'Dual collection: access not restricted',
          tooltip: `Unexpected. ${ONE_APP_TAG_DC} should always be paired with the restriction flag.`,
        };
  }
  return null;
}

export function MigrationLabels({ features }: { features: string[] }) {
  const labels = [
    getMigrationState(features),
    features.includes(HJ_MIGRATION_CSQ_TAG_ALREADY_LOADED) && {
      color: 'var(--red)',
      text: 'CSQ tag already loaded',
      tooltip:
        'Sites already load a CSQ tag, which blocks the sideloaded migration tag.',
    },
  ].filter((label): label is MigrationLabel => Boolean(label));

  return (
    <>
      {labels.map(({ color, text, tooltip }) => (
        <Tooltip key={text} title={tooltip}>
          <span>
            <ColoredLabel color={color}>{text}</ColoredLabel>
          </span>
        </Tooltip>
      ))}
    </>
  );
}
